/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { addDoc, collection, deleteDoc, doc, getDocs, onSnapshot, setDoc } from 'firebase/firestore'
import { firestore, auth } from '../../config/firebase'

let withdrawsUnsubscribe = null;
let withdrawsSubscribed = false;

export const startWithdrawsListener = createAsyncThunk(
  'withdraws/startListener',
  async (_, { dispatch }) => {
    if (withdrawsSubscribed) return;
    withdrawsSubscribed = true;

    const ref = collection(firestore, 'withdraws');
    withdrawsUnsubscribe = onSnapshot(ref, (snapshot) => {
      const withdrawsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Enhanced sorting by date AND time (newest first)
      const sortedWithdraws = withdrawsData.sort((a, b) => {
        // First sort by date
        const dateA = new Date(a.date || 0)
        const dateB = new Date(b.date || 0)
        
        if (dateA.getTime() !== dateB.getTime()) {
          return dateB - dateA // Newer dates first
        }
        
        // If same date, sort by Firestore document ID (which is time-ordered)
        if (a.id && b.id) {
          return b.id.localeCompare(a.id)
        }
        
        // Fallback to original order if no IDs
        return 0
      });
      
      console.log(`💰 Withdraws loaded: ${sortedWithdraws.length} items`)
      dispatch(setWithdraws(sortedWithdraws));
    });
  }
);

export const stopWithdrawsListener = createAsyncThunk(
  'withdraws/stopListener',
  async () => {
    if (withdrawsUnsubscribe) withdrawsUnsubscribe();
    withdrawsUnsubscribe = null;
    withdrawsSubscribed = false;
  }
);

// Keep the old function name for backward compatibility
export const getAllWithdraws = startWithdrawsListener;

export const addNewWithdraw = createAsyncThunk('auth/addNewWithdraw', async (data) => {
  const { close, ...rest } = data
  try {
    const WithdrawCollection = collection(firestore, 'withdraws')
    const optimisticData = {
      ...rest,
      creator: auth.currentUser.uid
    }
    await addDoc(WithdrawCollection, optimisticData)
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const updateWithdraw = createAsyncThunk('auth/updateWithdraw', async (data) => {
  const { close, id, ...rest } = data
  try {
    const WithdrawRef = doc(firestore, 'withdraws', id)
    const optimisticData = {
      ...rest
    }
    await setDoc(WithdrawRef, optimisticData, { merge: true })
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const deleteWithdraw = createAsyncThunk('auth/deleteWithdraw', async (data) => {
  const { close, id } = data
  try {
    const WithdrawRef = doc(firestore, 'withdraws', id)
    await deleteDoc(WithdrawRef)
    return id
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

const withdraws = createSlice({
  name: 'withdraws',
  initialState: {
    withdraws: [],
    loading: false,
    error: null
  },
  reducers: {
    setWithdraws: (state, action) => {
      state.withdraws = action.payload;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetWithdraws: (state) => {
      withdrawsSubscribed = false;
      state.withdraws = [];
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(startWithdrawsListener.pending, (state) => {
        state.loading = true
      })
      .addCase(startWithdrawsListener.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(startWithdrawsListener.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  }
})

export const { setWithdraws, setLoading, resetWithdraws } = withdraws.actions
export default withdraws.reducer
